import React from 'react';
import "./style.less";
import Anouncement from "~/assets/oznameni.jpg";

export default function AnouncementPage() {
	return <div className="anouncementPage">
		<h2 className="anouncementPage__title">Svatební oznámení</h2>
		<p className="anouncementPage__center">
			<img src={Anouncement} alt="Svatební oznámení" className="anouncementPage__img" />
		</p>
	</div>;
}
